export default __webpack_public_path__ + "assets/_Chapters/CTeileSortiment/Zerspanungsartikel/walter.jpg";